import * as Yup from 'yup';

export const validationFormSchema = Yup.object().shape({
  // approvalLevel: Yup.string().required('Required').nullable(),
  name: Yup.string().required('Required').nullable(),
  requiredBranchApprovalCount: Yup.string().required('Required').nullable(), // importanceLevel: Yup.string().required('Resquired').nullable(),
});
